if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.error = false;
        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);

        const upsellBox = document.querySelector('upsell-add-on');
        if (upsellBox) {
          const selectedUpsells = upsellBox.getSelectedProducts();

          if (selectedUpsells && selectedUpsells.length > 0) {
            selectedUpsells.forEach((product, index) => {
              formData.append(`items[${index + 1}][id]`, product.variantId);
              formData.append(`items[${index + 1}][quantity]`, 1);
            });
          }
        }

        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }

        config.body = formData;

        try {
          const result = await mrRunCartMutation(
            () => fetch(`${routes.cart_add_url}`, config),
            {
              maxRetries: 1,
              retryStatuses: [409],
              cooldownMs: 1200,
              onRetry: () => {
                this.handleErrorMessage('The cart changed while updating. Retrying…');
              },
            }
          );
          const response = result.payload;
          this.handleErrorMessage();

          if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'product-form',
            productVariantId: formData.get('id'),
            cartData: response,
          });

          const quickAddModal = this.closest('quick-add-modal');
          const quickViewModal = document.getElementById('product-modal');

          if (quickViewModal) {
            quickViewModal.classList.remove('active');
            document.body.classList.remove('quickview-open');
          }

          if (quickAddModal) {
            document.body.addEventListener(
              'modalClosed',
              () => {
                setTimeout(() => {
                  this.cart.renderContents(response);
                });
              },
              { once: true }
            );
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        } catch (error) {
          const message = mrCartMutationMessage(error);
          publish(PUB_SUB_EVENTS.cartError, {
            source: 'product-form',
            productVariantId: formData.get('id'),
            errors: message,
            message,
          });
          this.handleErrorMessage(message);
          console.error('[ProductForm] cart add failed:', error);
        } finally {
          this.error = false;
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading__spinner').classList.add('hidden');
        }
      }


      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}

async function mrRunCartMutation(fetcher, options) {
  if (window.MRCartMutationCoordinator) {
    return window.MRCartMutationCoordinator.mutate(fetcher, options);
  }

  const response = await fetcher({ attempt: 0 });
  const text = await response.text();
  let payload = null;
  if (text) {
    try {
      payload = JSON.parse(text);
    } catch (error) {
      payload = text;
    }
  }

  if (!response.ok) {
    const fallbackMessage = typeof payload === 'string'
      ? payload
      : payload?.description || payload?.message || 'Unable to update the cart.';
    const requestError = new Error(fallbackMessage);
    requestError.status = response.status;
    requestError.payload = payload;
    throw requestError;
  }

  return { ok: true, status: response.status, payload, response, attempt: 0 };
}

function mrCartMutationMessage(error) {
  if (error?.status === 429) {
    return 'To protect your cart from repeated automated requests, please refresh the page to verify your request, then try again.';
  }
  if (error?.status === 409) {
    return 'The cart changed while your request was being processed. Please refresh the page and try again.';
  }

  const payload = error?.payload;
  if (payload && typeof payload === 'object') {
    return payload.description || payload.message || error.message || 'Unable to add this item to the cart.';
  }
  return error?.message || 'Unable to add this item to the cart.';
}
